import React from 'react';
import PropTypes from 'prop-types';
import Chip from '@material-ui/core/Chip';

export default function EmailVerificationChip({
  emailVerified,
  onResendEmailVerification,
}) {
  return emailVerified ? (
    <Chip
      label="Email verifiziert"
      color="primary"
      style={{ backgroundColor: '#218e35', color: 'white' }}
    />
  ) : (
    <Chip
      label="Verifizierungs Email senden"
      style={{ backgroundColor: '#00acc1', color: 'white' }}
      color="secondary"
      clickable
      onClick={() => onResendEmailVerification()}
    />
  );
}

EmailVerificationChip.propTypes = {
  onResendEmailVerification: PropTypes.func.isRequired,
  emailVerified: PropTypes.bool.isRequired,
};



// WEBPACK FOOTER //
// ./src/views/users/components/EmailVerificationChip.jsx